<template>
  <el-tag
    v-if="text"
    :type="value < 150 ? 'danger' : 'primary'"
    :hit="true"
    size="small"
  >
    <el-tooltip
      effect="dark"
      placement="top"
      content="Total volume available for chosen geo, device and OS targeting. Doesn't include frequency capping or creative quality restrictions."
    >
      {{ text }}
    </el-tooltip>
  </el-tag>
</template>

<script lang="ts">
import { defineComponent, computed } from 'vue'
export default defineComponent({
  name: 'AvailableTrafficLabel',
  props: {
    modelValue: {
      type: Number,
      required: true
    }
  },
  setup(props) {
    const formatTraffic = (value: number) => {
      const units = ['', 'K', 'M', 'G', 'T']
      let amount = Math.ceil(value)
      let unitIndex = 0

      while (amount > 999 && unitIndex < units.length - 1) {
        amount = Math.ceil(amount / 1000)
        unitIndex += 1
      }

      return `${amount}${units[unitIndex]}`
    }
    const text = computed(() => {
      return `Available traffic: ${formatTraffic(props.modelValue)} per day`
    })
    return { text }
  }
})
</script>
<style lang="scss" scoped>
.el-tag {
  margin-left: 5px;
  border: none !important;
  max-width: 190px;
  vertical-align: middle;

  :deep(.el-tag__content) {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}
</style>
